export const TIME_CATEGORY_BLOCK_HEIGHT = 96;
export const BATCH_NUMBER_STATUS_LINKED_INFO_BLOCK_WIDTH = 265;